import { createFeatureSelector } from "@ngrx/store";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";

/**
 * Selector for list environment
 */
export const listEnvironment = createFeatureSelector<GenericStoreApiData>(
  AppSettings.KEY_ENVIRONMENT
);

/**
 * Selector for list environment access user openable
 */
export const listEnvironmentAccessUserOpenable =
  createFeatureSelector<GenericStoreApiData>(
    AppSettings.KEY_ENVIRONMENT_ACCESS_USER_OPENABLE
  );
//

/**
 * Selector for list environment with the relative devices
 */
export const listEnvironmentDevices =
  createFeatureSelector<GenericStoreApiData>(
    AppSettings.KEY_ENVIRONMENT_DEVICE
  );
//

/**
 * Selector for access control maintanance
 */
export const listEnvironmentAccessControlMaintanance =
  createFeatureSelector<GenericStoreApiData>(
    AppSettings.KEY_ENVIRONMENT_ACCESS_CONTROL_MAINTANANCE
  );
